import React, { useMemo, useState } from "react";
import {
    CommonDiscussParams,
    getDiscussDetail,
    SortType,
    TopicType
} from "service/discuss";
import useRequest from "utils/useRequest";
import { getCourseInfo } from "service/course";
import scrollTo from "antd/lib/_util/scrollTo";
import { DiscussContent } from "pages/AskTeacher/AskTeacherDetail/context";
import { isTrue } from "../../../../service/service";
import moment from "moment";

interface DiscussProviderProps extends CommonDiscussParams {
    topicType: TopicType; // 主题类型（0主题讨论 1答疑）
    uuid: string;
    children: React.ReactNode;
}

export function DiscussProvider({
    topicType,
    uuid,
    courseNo,
    courseSeq,
    batchNo,
    children
}: DiscussProviderProps) {
    const [sort, setSort] = useState(SortType.All);
    const [isWriting, setIsWriting] = useState(false);

    const [discussDetail, { loading }, updateDiscussDetail] = useRequest(
        async () => {
            return getDiscussDetail({
                uuid,
                courseNo,
                courseSeq,
                batchNo,
                sort
            });
        },
        {},
        [uuid, courseNo, courseSeq, batchNo, sort]
    );

    function onEditAnswer(isWriting: boolean) {
        setIsWriting(isWriting);

        if (isWriting) {
            const rect = document
                .querySelector("#DiscussTopic")!
                .getBoundingClientRect();

            scrollTo(rect.height + 80);
        }
    }

    const [course] = useRequest(() =>
        getCourseInfo({ courseNo, courseSeq, batchNo })
    );

    const [editUuid, setEditUuid] = useState<string | null>(null);

    const isDead = useMemo(() => {
        return (
            isTrue(discussDetail?.isStart) &&
            moment(discussDetail?.deadline).isBefore()
        );
    }, [discussDetail]);

    return (
        <DiscussContent.Provider
            value={{
                topicType,
                uuid,
                courseNo,
                courseSeq,
                batchNo,
                sort,
                setSort,
                editUuid,
                setEditUuid,
                isDead,
                loading,
                isWriting,
                setIsWriting: onEditAnswer,
                course,
                discussDetail,
                updateDiscussDetail
            }}>
            {children}
        </DiscussContent.Provider>
    );
}
